<template>
  <transition name="fade-in">
    <div
      v-if="showPopup"
      class="cookie-consent-popup position-fixed bottom-0 start-50 translate-middle-x w-100 p-4  bg-white shadow-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-consent-title"
    >
      <h2 id="cookie-consent-title" class="h5 mb-2">Cookies & meetgegevens</h2>
      <p class="small mb-3">
        Deze applicatie gebruikt cookies voor functionele doeleinden en andere technieken om inzicht te krijgen in bezoekersaantallen en advertentieprestaties. U kunt toestemming geven of doorgaan zonder cookies. Lees meer in onze
        <a href="https://bureauverduurzamen.nl/privacy/" target="_blank" rel="noopener">privacyverklaring</a>.
      </p>

      <button-row class="justify-content-between">
        <base-button variant="minimal-secondary" icon="bi-x" icon-position="start" @click="onReject">
          Optionele cookies afwijzen
        </base-button>
        <base-button icon="bi-check2" icon-position="start" @click="onAccept">Accepteren</base-button>
      </button-row>
    </div>
  </transition>
</template>

<script>
  import BaseButton from '@/components/BaseButton.vue';
  import ButtonRow from '@/components/ButtonRow.vue';
  import { getCookieConsentValue, hasCookieConsentDecision, setCookieConsent } from '@/helpers/CookieConsent';
  import { FacebookPixelService } from '@/services/FacebookPixelService';
  import { GoogleAnalyticsService } from '@/services/GoogleAnalyticsService';
  import { useLeadStore } from '@/store/LeadStore';

  export default {
    components: {
      BaseButton,
      ButtonRow
    },
    setup() {
      const lead = useLeadStore();

      return { lead };
    },
    data() {
      return {
        decisionMade: hasCookieConsentDecision()
      };
    },
    computed: {
      showPopup() {
        return !this.decisionMade;
      }
    },
    mounted() {
      if (hasCookieConsentDecision()) {
        this.lead.setCookiesAccepted(getCookieConsentValue());
      }
    },
    methods: {
      onAccept() {
        setCookieConsent(true);
        this.lead.setCookiesAccepted(true);
        GoogleAnalyticsService.load();
        FacebookPixelService.load();
        this.decisionMade = true;
      },
      onReject() {
        setCookieConsent(false);
        this.lead.setCookiesAccepted(false);
        GoogleAnalyticsService.unload();
        FacebookPixelService.unload();
        this.decisionMade = true;
      }
    }
  }
</script>

<style scoped lang="scss">
  .cookie-consent-popup {
    z-index: 2000;
    border-radius: $border-radius * 2;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    max-width: 640px;
  }
</style>
